export default __webpack_public_path__ + "static/media/tc-fig3.ec2af755.svg";